module.exports = "../../app/cells/components/campaigns/widgets/remaining_amount_tag_cell.rb";